import React from 'react';
import Directory from './components/Directory';
import FAQ from './components/FAQ';
import FeatureGrid from './components/FeatureGrid';
import Hero from './components/Hero';
import PrivacyPolicy from './components/PrivacyPolicy';
import Process from './components/Process';
import Resources from './components/Resources';
import './App.css';
import './branding.css';

function AirflowLogo() {
  return (
    <span className="site-brand-icon airflow-logo" aria-hidden="true">
      <svg viewBox="0 0 32 32" role="presentation">
        <path className="airflow-line airflow-blue" d="M4 9c5-4 8 4 13 0s7-3 11 0" />
        <path className="airflow-line airflow-red" d="M4 16c5-4 8 4 13 0s7-3 11 0" />
        <path className="airflow-line airflow-blue" d="M4 23c5-4 8 4 13 0s7-3 11 0" />
      </svg>
    </span>
  );
}

function App() {
  if (window.location.pathname === '/privacy-policy') {
    return <PrivacyPolicy />;
  }

  return (
    <div className="app">
      <header className="site-header">
        <a
          className="site-brand"
          href="/"
          aria-label="HVAC Classes Houston"
        >
          <AirflowLogo />
          <span>HVAC Classes Houston</span>
        </a>
      </header>

      <Hero />

      <main>
        <Directory />
        <FeatureGrid />
        <Process />
        <FAQ />
      </main>

      <Resources />
    </div>
  );
}

export default App;